import { ColorTextCard } from "features/forms/personas/cards/ColorTextCard";
import { useSelector } from "react-redux";
import EditModeSwitch from "shared/components/edit-mode-switch";
import GenericTypeahead from "shared/dropdowns/GenericTypeahead";
import { SwitchProvider } from "shared/dynamic-imports";

export default function SystemDropdown({ object, link, unlink,attributeName, isSwitchDisabled }) {
	const libraries = useSelector((state) => state.libraries?.customLibraries) || [];
	const allSystems = libraries?.find((l) => l.name === "Systems" && l.isCustom === false)?.values;
	const linkedIds = object?.[attributeName] || object?.linkedSystems || []

	const linkedSystems = allSystems?.filter((s) => linkedIds?.includes(s?.id));

	const renderReadOnlyItems = () => (
		<>
			{linkedSystems?.map((system) => (
				<div key={system?.id}>
					<ColorTextCard key={system?.id} text={system?.name} color={system?.colorCode} className="p-1" height="2.25rem" fontSize="14px" showBorder={false} />
				</div>
			))}
		</>
	);

	const params = {
		selected: linkedSystems,
		options: allSystems,
		renderSelectedItem: (system) => (
			<ColorTextCard
				key={system?.id}
				text={system?.name}
				color={system?.colorCode}
				className="p-1"
				height="2.25rem"
				fontSize="14px"
				onRemove={() => unlink(system?.id)}
				isEdit={true}
				showBorder={false}
			/>
		),
		renderMenuItem: ({ item }) => (
			<ColorTextCard key={item?.id} text={item?.name} color={item?.colorCode} className="p-1" height="2.25rem" fontSize="14px" showBorder={false}/>
		),
		linkMenuItem: ({ item }) => link(item.id),
		filter: ({ query, option }) => {
			const system = allSystems?.find((s) => s.id === option?.id);
			if (system && !linkedSystems?.map((ls) => ls?.id)?.includes(option?.id)) return system?.name?.toLowerCase().includes(query?.toLowerCase());
		},
	};

	return (
		<SwitchProvider isDisabled={isSwitchDisabled}>
			<EditModeSwitch addLabel="ADD_SYSTEM" renderReadOnlyItems={renderReadOnlyItems} isEmpty={linkedSystems?.length === 0} isDisabled={isSwitchDisabled}>
				<GenericTypeahead {...params} />
			</EditModeSwitch>
		</SwitchProvider>
	);
}
